// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sw1m","newExpiryDate":"styles_newExpiryDate__14vEl","footer":"styles_footer__39a9z"};